import React from 'react';
import { Avatar } from 'stream-chat-react';

const ThreadCustomMessage = (props) => {
  const { message } = props;

  return (
    <div style={{ padding: '10px', borderBottom: '1px solid #eee' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar image={message.user?.photo} name={message.user?.name || message.user?.id} />
        <div style={{ marginLeft: '10px' }}>
          <strong>{message.user?.name || message.user?.id}</strong>
          <div>{message.text}</div>
        </div>
      </div>
    </div>
  );
};

export default ThreadCustomMessage;
